import styles from "./SectionHeader.module.css";

const SectionHeader = ({
  title,
  isTextBold = false,
  invert = false,
  className,
}) => {
  const words = title.trim().split(/\s+/);
  const lastWord = words.pop();
  const mainTitle = words.join(" ");
  const titleClassNames = [
    styles.title,
    isTextBold ? styles.bolder : styles.lighter,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <h1 className={titleClassNames}>
      {mainTitle ? `${mainTitle} ` : ""}
      <span className={invert ? styles.inverted : styles.highlighted}>
        {lastWord}
      </span>
    </h1>
  );
};

export default SectionHeader;
